import { useRouter } from 'next/router'
import { useEffect, useState, VFC } from 'react'
import { MatchingStatusType, RoomStatusType } from 'src/models/Room'
import { convertMessagePageQuqry, toMessagePageQuery } from 'src/utils/routes'
import styled, { css } from 'styled-components'

import {
  MESSAGE_FILTER_SP,
  MESSAGE_ROOM_TYPE_SP,
  MESSAGE_SELECTED_FILTER_SP,
  MESSAGE_SELECTED_ROOM_TYPE_SP,
} from 'src/assets/images'
import { _filterborder, _profilegreen } from 'src/styles/colors'

type FilterPrpops = {
  activeMatchingStatus: MatchingStatusType
  activeRoomStatus: RoomStatusType
}
export const Filter: VFC<FilterPrpops> = ({
  activeMatchingStatus,
  activeRoomStatus,
}) => {
  const [filterOpened, setFilterOpened] = useState(false)
  const [roomTypeFilterOpened, setRoomTypeFilterOpened] = useState(false)

  const [matchingStatus, setMatchingStatus] =
    useState<MatchingStatusType>('all_room')
  const [roomStatus, setRoomStatus] = useState<
    RoomStatusType | 'company_message_room' | 'company_message_group_room'
  >('unspecified')

  useEffect(() => {
    setMatchingStatus(activeMatchingStatus)
  }, [activeMatchingStatus])
  useEffect(() => {
    setRoomStatus(activeRoomStatus)
  }, [activeRoomStatus])

  const router = useRouter()
  const query = convertMessagePageQuqry(router.query)
  const updateMatchingStatusQuery = (value?: MatchingStatusType) => {
    router.push(
      toMessagePageQuery({
        pathname: router.pathname,
        query: {
          ...query,
          matching_status: value,
        },
      }),
    )
  }
  const updateRoomStatusQuery = (value: RoomStatusType) => {
    router.push(
      toMessagePageQuery({
        pathname: router.pathname,
        query: {
          ...query,
          unread_only: value === 'unread_only' ? 'true' : null,
          room_type:
            value === 'company_message_room' ||
            value === 'company_message_group_room'
              ? value
              : null,
        },
      }),
    )
  }

  return (
    <FilterContainer>
      <ButtonGroup>
        <ButtonImage
          src={filterOpened ? MESSAGE_SELECTED_FILTER_SP : MESSAGE_FILTER_SP}
          alt=""
          onClick={() => {
            if (filterOpened) setFilterOpened(false)
            else {
              setFilterOpened(true)
              setRoomTypeFilterOpened(false)
            }
          }}
          height={filterOpened ? 38 : 32}
        />
        <ButtonImage
          src={
            roomTypeFilterOpened
              ? MESSAGE_SELECTED_ROOM_TYPE_SP
              : MESSAGE_ROOM_TYPE_SP
          }
          alt=""
          height={roomTypeFilterOpened ? 38 : 32}
          onClick={() => {
            if (roomTypeFilterOpened) setRoomTypeFilterOpened(false)
            else {
              setFilterOpened(false)
              setRoomTypeFilterOpened(true)
            }
          }}
        />
      </ButtonGroup>
      {filterOpened && (
        <FilterCard>
          <FilterText>選択された条件のルームのみ表示</FilterText>
          <FilterOptions>
            <Option
              onClick={() => {
                if (roomStatus === 'unread_only')
                  updateRoomStatusQuery('unspecified')
                else updateRoomStatusQuery('unread_only')
              }}
              selected={roomStatus === 'unread_only'}
            >
              未読
            </Option>
            <Option
              onClick={() => {
                if (roomStatus === 'company_message_room')
                  updateRoomStatusQuery('unspecified')
                else updateRoomStatusQuery('company_message_room')
              }}
              selected={roomStatus === 'company_message_room'}
            >
              2社間
            </Option>
            <Option
              onClick={() => {
                if (roomStatus === 'company_message_group_room')
                  updateRoomStatusQuery('unspecified')
                else updateRoomStatusQuery('company_message_group_room')
              }}
              selected={roomStatus === 'company_message_group_room'}
            >
              3社間
            </Option>
          </FilterOptions>
        </FilterCard>
      )}
      {roomTypeFilterOpened && (
        <FilterCard2>
          <FilterOptions>
            <Option
              onClick={() => {
                if (matchingStatus === 'all_room')
                  updateMatchingStatusQuery('all_room')
                else updateMatchingStatusQuery('all_room')
              }}
              selected={matchingStatus === 'all_room'}
            >
              すべて
            </Option>
            <Option
              onClick={() => {
                if (matchingStatus === 'is_messaging')
                  updateMatchingStatusQuery('all_room')
                else updateMatchingStatusQuery('is_messaging')
              }}
              selected={matchingStatus === 'is_messaging'}
            >
              メッセージ中
            </Option>
            <Option
              onClick={() => {
                if (matchingStatus === 'matching_request')
                  updateMatchingStatusQuery('all_room')
                else updateMatchingStatusQuery('matching_request')
              }}
              selected={matchingStatus === 'matching_request'}
            >
              つながり申請中
            </Option>
          </FilterOptions>
        </FilterCard2>
      )}
    </FilterContainer>
  )
}

const FilterContainer = styled.div`
  position: relative;
  display: none;
  @media screen and (max-width: 960px) {
    display: block;
  }
`
const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
`
const ButtonImage = styled.img`
  cursor: pointer;
`
const FilterCard = styled.div`
  border: 1px solid ${_filterborder};
  border-radius: 0 6px 6px;
  padding: 16px;
`
const FilterCard2 = styled.div`
  border: 1px solid ${_filterborder};
  border-radius: 6px 0 6px 6px;
  padding: 16px;
`
const FilterText = styled.p`
  font-size: 14px;
  margin-bottom: 12px;
`
const FilterOptions = styled.div`
  display: flex;
  flex-wrap: wrap;
`
const Option = styled.button<{ selected?: boolean }>`
  padding: 6px 12px;
  margin-right: 8px;
  border: 1px solid #ccc;
  border-radius: 16px;
  cursor: pointer;
  font-size: 14px;
  ${({ selected }) =>
    selected &&
    css`
      background-color: ${_profilegreen};
      color: white;
      border: none;
    `}
`
